import axios from "axios";
import appConfig from "../config/appConfig";

const API_BASE = `${String(appConfig.apiBase || "").replace(/\/$/, "")}/vitals`;

const headersFor = (clinicId) => ({ "X-Clinic-Id": String(clinicId || "") });

export const vitalMeasurementService = {
  async getSpecialties() {
    const response = await axios.get(`${API_BASE}/measurement-specialties`);
    return response.data;
  },

  async getLibrary({ doctorId, clinicId, category, specialty, search } = {}) {
    const response = await axios.get(`${API_BASE}/measurement-library`, {
      headers: doctorId ? headersFor(clinicId) : undefined,
      params: { doctorId, category, specialty, search },
    });
    return response.data;
  },

  async getDoctorSettings(doctorId, clinicId) {
    const response = await axios.get(`${API_BASE}/doctors/${doctorId}/measurement-settings`, {
      headers: headersFor(clinicId),
    });
    return response.data;
  },

  async saveDoctorSettings(doctorId, clinicId, measurements) {
    const response = await axios.put(
      `${API_BASE}/doctors/${doctorId}/measurement-settings`,
      { measurements },
      { headers: headersFor(clinicId) },
    );
    return response.data;
  },

  async resetDoctorSetting(doctorId, clinicId, measurementId) {
    await axios.delete(`${API_BASE}/doctors/${doctorId}/measurement-settings/${measurementId}`, {
      headers: headersFor(clinicId),
    });
  },

  async createCustomMeasurement(doctorId, clinicId, measurement) {
    const response = await axios.post(
      `${API_BASE}/doctors/${doctorId}/custom-measurements`,
      measurement,
      { headers: headersFor(clinicId) },
    );
    return response.data;
  },

  async getAppointmentMeasurements(appointmentId, doctorId, clinicId) {
    const response = await axios.get(`${API_BASE}/appointments/${appointmentId}/measurements`, {
      headers: headersFor(clinicId),
      params: { doctorId },
    });
    return response.data;
  },

  async saveAppointmentMeasurements(appointmentId, doctorId, clinicId, measurements) {
    const response = await axios.post(
      `${API_BASE}/appointments/${appointmentId}/measurements`,
      { measurements },
      { headers: headersFor(clinicId), params: { doctorId } },
    );
    return response.data;
  },

  async deleteAppointmentMeasurement(appointmentId, doctorId, clinicId, observationId) {
    await axios.delete(`${API_BASE}/appointments/${appointmentId}/measurements/${observationId}`, {
      headers: headersFor(clinicId),
      params: { doctorId },
    });
  },

  async getPatientMeasurements(patientId, clinicId) {
    const response = await axios.get(`${API_BASE}/patients/${patientId}/measurements`, {
      headers: headersFor(clinicId),
    });
    return response.data;
  },
};
